'use strict';

/**
 * Azure regions
 *
 */
module.exports = {
    centralUs: 'centralus',
    eastUs: 'eastus',
    eastUs2: 'eastus2',
    southCentralUs: 'southcentralus',
    westUs2: 'westus2',
    westUs3: 'westus3',
    westUs: 'westus',
    westCentralUs: 'westcentralus',
    northCentralUs: 'northcentralus',

    canadaCentral: 'canadacentral',
    canadaEast: 'canadaeast',

    australiaEast: 'australiaeast',
    australiaCentral: 'australiacentral',
    australiaSouthEast: 'australiasoutheast',

    northEurope: 'northeurope',
    westEurope: 'westeurope',

    eastAsia: 'eastasia',
    southeastAsia: 'southeastasia',

    southAfricaNorth: 'southafricanorth',

    centralIndia: 'centralindia',
    southIndia: 'southindia',
    westIndia: 'westindia',

    japanEast: 'japaneast',
    japanWest: 'japanwest',

    koreaCentral: 'koreacentral',
    koreaSouth: 'koreasouth',

    ukSouth: 'uksouth',
    ukWest: 'ukwest',

    swedenCentral: 'swedencentral',
    franceCentral: 'francecentral',
    germanyWestCentral: 'germanywestcentral',
    norwayEast: 'norwayeast',
    switzerlandNorth: 'switzerlandnorth',
    uaeNorth: 'uaenorth',
    brazilSouth: 'brazilsouth',
    qatarCentral: 'qatarcentral'
};